
import { yearsToDash, cleanPriceValue } from '~/plugins/filters'

export default {
    name: 'SectorChart',
    props: {
        chartData: Array,
        price: {
            type: Array,
            default() {
                return []
            },
        },
    },

    data() {
        return {
            chart1: undefined,
            chart2: undefined,
            cnt: [],
            date: [],
            priceDate: [],
            priceValue: [],
        }
    },
    watch: {
        chartData() {
            // TODO: watch가 3번이나 보는 부분 확인하기
            console.log('WATCHED!')
            // 데이터 들어오면 초기화
            this.cnt = []
            this.date = []

            // this.chart2.destroy()

            this.pushDateCnt()
            this.drawSectorChart()
        },
        price() {
            this.priceDate = []
            this.priceValue = []

            // this.chart1.destroy()

            this.pushPriceCnt()
            this.drawPriceChart()
        },
    },
    destroyed() {
        this.chart1.destroy()
        this.chart2.destroy()
    },
    created() {
        this.pushPriceCnt()
        this.pushDateCnt()
    },

    mounted() {
        this.drawPriceChart()
        this.drawSectorChart()
    },
    methods: {
        drawSectorChart() {
            this.chart2 = window.bb.generate({
                data: {
                    x: 'x',
                    columns: [
                        ['x', ...this.date],
                        ['섹터', ...this.cnt],
                    ],
                    type: 'bubble',
                    labels: true,
                },
                bubble: {
                    maxR: 15,
                },
                axis: {
                    x: {
                        type: 'timeseries',
                        tick: {
                            count: 52,
                            format: '%Y-%m-%d',
                        },
                    },
                    y: {
                        label: {
                            text: '(횟수)',
                            position: 'outer-middle',
                        },
                    },
                },
                bindto: this.$refs.chart2,
            })
            this.chart2.zoom.enable(false)
        },
        drawPriceChart() {
            this.chart1 = window.bb.generate({
                data: {
                    x: 'x',
                    columns: [
                        ['x', ...this.priceDate],
                        ['주가', ...this.priceValue],
                    ],
                },
                padding: {
                    left: 50,
                },
                point: {
                    show: false,
                },
                color: {
                    pattern: ['#6799FF'],
                },
                axis: {
                    x: {
                        type: 'timeseries',
                        tick: {
                            count: 52,
                            format: '%Y-%m-%d',
                        },
                    },
                    y: {
                        label: {
                            text: '(원)',
                            position: 'inner-top',
                        },
                        tick: {
                            format(x) {
                                return window.d3.format(',')(x)
                            },
                        },
                    },
                },
                bindto: this.$refs.chart1,
            })
            this.chart1.zoom.enable(false)
        },

        pushDateCnt() {
            try {
                // count
                for (const item of this.chartData) {
                    this.date.push(yearsToDash(item.showDate))
                    this.cnt.push(item.count)
                }
            } catch (e) {
                // TODO: error 처리 (list의 length가 0 일 때)
                console.log('error=', e)
            }
        },

        pushPriceCnt() {
            try {
                // price
                for (const item of this.price) {
                    this.priceDate.push(yearsToDash(item.date))
                    this.priceValue.push(cleanPriceValue(item.price))
                }
            } catch (e) {
                // TODO: error 처리 (list의 length가 0 일 때)
                console.log('error=', e)
            }
        },
    },
}
